import { combineReducers } from 'redux';
// Import reducers
import table from './software_panel_reducer';
import form from './software_form_reducer';

export default combineReducers({
	table,
	form
});
